import { usePageTitle } from '@app/hooks';
import { useStore } from 'effector-react';
import React, { useEffect } from 'react';
import { $coreUser } from '../../store/states';

const CoreUserEscalationLog: React.FC = () => {
    const { changeTitle } = usePageTitle('Member Escalation Log');
    
    const coreUser = useStore($coreUser);

    useEffect(() => {
        if (!coreUser) {
            return;
        }

        changeTitle(`Member Escalation Log - ${coreUser.first_name} ${coreUser.last_name}`);
    }, [coreUser?.first_name, coreUser?.last_name]);

    return <div>CoreUserEscalationLog</div>;
};

export default CoreUserEscalationLog;
